module.exports = __webpack_public_path__ + "img/Two Peck.1bff6145.svg";